import React from 'react';
import {IntegrationEmptyCard} from '../IntegrationDesign';

export default function ServerNoIntegrationsView(props) {
    const addIntegration = () => props.history.push({pathname: '/settings/integrations/add-server', state: {background: props.location}});
    return <IntegrationEmptyCard title='Servers & domains' description='Connect hosting and domain providers to manage deployments and SSL certificates.' onAdd={addIntegration}
        features={['Deploy websites on AWS.', 'Issue SSL certificates automatically.']}/>;
}
